<template>
  <div>
    <div class="wreppaer">
      <div class="re_dian">
        <p class="dian_shi">热点赛事</p>
        <p class="dian_wen">MORE</p>
      </div>
      <div class="dian_center">
        <div class="dian_lie" v-for="(item,index) in matchData">
          <div class="lie_img">
            <img :src="item.image.substring(2,item.image.length-2)" alt />
          </div>
          <p @click="details(index)">{{item.title}}</p>
        </div>
      </div>
      <div class="re_dian zi_xun">
        <p class="dian_shi">新闻资讯</p>
        <p class="dian_wen">MORE</p>
      </div>
      <div class="dian_zi" v-for="(item,index) in newData">
        <p @click="xiang(index)">{{item.title}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      matchData: [],
      page: "",
      pageSize: "6",
      newData: [],
      id: ""
    };
  },
  watch: {},
  mounted() {
    let that = this;
    that.$http
      .get(
        that.g.ajaxurl +
          "attentions/indexw?page=" +
          that.page +
          "&pageSize=" +
          that.pageSize
      )
      .then(res => {
        // console.log(res);
        that.matchData = res.data.data.items;
      });
    this.games_app();
  },
  methods: {
    sign() {
      this.$router.push({
        path: "/signIn"
      });
    },
    details: function(a) {
      console.log(a);
      this.$router.push({
        path: "/Tournament",
        query: {
          id: this.matchData[a].id
        }
      });
    },
    xiang: function(a) {
      this.id = this.newData[a].id;
      this.$router.push({
        path: "/chessnews",
        query: {
          id: this.id
        }
      });
    },
    games_app: function() {
      let that = this;
      // let token = JSON.parse(localStorage.getItem("username")).code;
      that.$http
        .get(that.g.ajaxurl + "teams/new", {
          // headers: {
          //   Authorization: "Basic " + window.btoa(token + ":")
          // }
        })
        .then(res => {
          this.newData = res.data.data;
        });
    }
  }
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
}
.re_dian {
  width: 100%;
  border-bottom: solid 2px #e50005;
  display: flex;
  justify-content: space-between;
}
.dian_shi {
  font-size: 0.2rem;
  background: #e50005;
  line-height: 0.4rem;
  color: #fff;
  padding: 0 0.3rem;
  border-radius: 5px 5px 0 0;
}
.dian_wen {
  font-size: 0.2rem;
  color: #e50005;
  line-height: 0.4rem;
}
.dian_center {
  width: 100%;
}
.dian_lie {
  display: flex;
  justify-content: flex-start;
  border-bottom: solid 1px #ccc;
  margin-top: 0.1rem;
  padding-bottom: 0.2rem;
}
.lie_img {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.1rem;
}
.lie_img img {
  width: 0.6rem;
  height: 0.6rem;
  float: left;
  border-radius: 5px;
}
.dian_lie p {
  font-size: 0.18rem;
  cursor: pointer;
}
.dian_lie p:hover {
  color: #fe8f24;
}
.zi_xun {
  margin-top: 0.3rem;
}
.dian_zi {
  width: 100%;
}
.dian_zi p {
  line-height: 0.3rem;
  border-bottom: solid 1px #ccc;
  font-size: 0.2rem;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0.1rem;
  cursor: pointer;
}
.dian_zi p:hover {
  color: #fe8f24;
}
</style>


// WEBPACK FOOTER //
// src/components/section/section.vue